import ChangeDescription from '../../../../infrastructure/types/DifferenceVisualizer/ChangeDescription';
import ColumnDefinition from '../../../../infrastructure/types/DataGrid/ColumnDefinition';
import React from 'react';
import typeHelper from '../../../../infrastructure/helpers/common/typeHelper';
import ModuleComponent from '../../../../infrastructure/types/DifferenceVisualizer/ModuleComponent';

const getDiffContent = (value: string, className: string): JSX.Element | string => {

    if (!typeHelper.isString(value)) {

        return 'n/a';
    }

    return (
        <p className={className}>{value}</p>
    );
};

const moduleColumn: ColumnDefinition<ChangeDescription> = {
    header: 'Module',
    getContent: x => x.module,
    width: '10%'
};

const moduleRefColumn: ColumnDefinition<ChangeDescription> = {
    header: 'Module Ref',
    getContent: x => x.moduleRef,
    width: '5%',
    className: 'break-all'
};

const getChanges = (value: ChangeDescription, onShowChangedClick?: (value: ChangeDescription) => void): JSX.Element | string => {

    return value.moduleComponent === ModuleComponent.Logic ? < button className='btn cb-btn' onClick={() => onShowChangedClick && onShowChangedClick(value)}> {'Compare'}
    </button> : ''
};

const commonColumns = (onShowChangedClick?: (value: ChangeDescription) => void): ColumnDefinition<ChangeDescription>[] => {
    return [
        {
            header: 'Module Name',
            getContent: x => x.moduleName,
            className: 'break-all',
            width: '10%'
        },
        {
            header: 'Module Component',
            getContent: x => x.moduleComponent,
            width: '10%'
        },
        {
            header: 'Before',
            getContent: x => getDiffContent(x.previous, 'before'),
            width: '30%'
        },
        {
            header: 'After',
            getContent: x => getDiffContent(x.current, 'after'),
            width: '30%'
        },
        {
            header: '',
            getContent: x => getChanges(x, onShowChangedClick),
            width: '5%'
        }
    ];
}
export { moduleColumn, moduleRefColumn, commonColumns };
